/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Build_Auto_DescInputs */

const en_mk_build_auto_desc = /** @type {(inputs: Mk_Build_Auto_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bystep builds step by step. Preview your app and review the results in your browser.`)
};

const id_mk_build_auto_desc = /** @type {(inputs: Mk_Build_Auto_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bystep mengerjakan langkah demi langkah. Lihat pratinjau aplikasi dan tinjau hasilnya di browser.`)
};

/**
* | output |
* | --- |
* | "Bystep builds step by step. Preview your app and review the results in your browser." |
*
* @param {Mk_Build_Auto_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_build_auto_desc = /** @type {((inputs?: Mk_Build_Auto_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Build_Auto_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_build_auto_desc(inputs)
	return en_mk_build_auto_desc(inputs)
});